import clone from 'lodash/clone.js';
import first from 'lodash/first.js';
import get from 'lodash/get.js';
import has from 'lodash/has.js';

export default class Gate {
    static policies = {};

    constructor(store) {
        this.$store = store;
    }

    forUser(user) {
        this.user = user;

        return this;
    }

    before() {
        if (!this.user) {
            return false;
        }

        return undefined;
    }

    allows(action, model) {
        const beforeGlobal = this.before();

        if (beforeGlobal !== undefined) {
            return beforeGlobal;
        }

        const { modelClass, args } = Gate.modelArgs(model);

        if (this.user && Object.hasOwn(Gate.policies, modelClass)) {
            const policy = new Gate.policies[modelClass](this.user);

            policy.setStore(this.$store);

            // Calling "before" will be skipped if the action starts with "_" (_modify e.g.)
            if (typeof policy.before === 'function' && action.charAt(0) !== '_') {
                const beforePolicy = policy.before(this.user);

                if (beforePolicy !== undefined && beforePolicy !== null) {
                    return beforePolicy;
                }
            }

            const realAction = action.charAt(0) === '_' ? action.substr(1) : action;

            if (typeof policy[realAction] === 'function') {
                return policy[realAction](this.user, ...args);
            }

            return false;
        } else {
            console.error(
                `Could not determine policy method. Please ensure there is a policy for action "${action}" and policy class: "${modelClass}"`
            );

            console.error('Available policies: ', Gate.policies);
            return false;
        }
    }

    denies(action, model) {
        return !this.allows(action, model);
    }

    userCan(permission) {
        return this.user.hasPermissionTo(permission);
    }

    userCanViaGroup(permission) {
        return this.user.hasGroupPermissionTo(permission);
    }

    static userRelationships() {
        return [
            'roles.permissions',
            'permissions',
            'user_groups.role.permissions',
            'user_groups.group',
            'enrollments.roles',
            'enrollments.statuses',
        ];
    }

    static registerPolicy(policy, modelName) {
        Gate.policies[modelName] = policy;
    }

    static modelArgs(model) {
        if (Array.isArray(model)) {
            const modelInfo = first(model);

            return {
                modelClass: typeof modelInfo === 'object' ? modelInfo.constructor.modelName : modelInfo,
                args: model.splice(1),
            };
        }

        if (has(model, 'modelName')) {
            return {
                modelClass: model.modelName,
                args: [model],
            };
        }

        return {
            modelClass: get(model, 'constructor.modelName', model),
            args: [model],
        };
    }

    registeredPolicies() {
        return clone(Gate.policies);
    }
}
